import type { HomePageFourPillars } from "../services/HomeService";
import type { DailyBalanceRingMetric } from "../components/HomePage/DailyBalanceCard";

export const mapFourPillarsToRings = (
  pillars: HomePageFourPillars,
): DailyBalanceRingMetric[] => [
  {
    label: "Glucose",
    value: pillars.glucose_score,
    variant: "orange",
  },
  {
    label: "Microbiome",
    value: pillars.microbiome_score,
    variant: "dark",
  },
  {
    label: "Physical Score",
    value: pillars.pas_score,
    variant: "dark",
  },
  {
    label: "Weight",
    value: pillars.wms_score,
    variant: "dark",
  },
];

export const hasFourPillarsData = (
  pillars: HomePageFourPillars | undefined,
): pillars is HomePageFourPillars =>
  Boolean(
    pillars &&
      [
        pillars.daily_balance,
        pillars.glucose_score,
        pillars.pas_score,
        pillars.microbiome_score,
        pillars.wms_score,
      ].some((v) => typeof v === "number" && Number.isFinite(v)),
  );
